__turbopack_context__.v({
  "className": "lato_a0d28f50-module__4LYwIq__className",
});
